import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import ConfirmationModal from '../common/ConfirmationModal';
import CommonMantineTable from '../common/CommonTable';
const UserTable = ({ data = [], setUsers, onEdit, onDelete, userType }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const openConfirmationModal = (userId) => {
    setUserToDelete(userId);
    setIsModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (userToDelete !== null && onDelete) {
      onDelete(userToDelete);
    }
    setIsModalOpen(false);
    setUserToDelete(null);
  };

  const baseColumns = [
    {
      accessorKey: 'name',
      header: 'Name',
      size: 180,
      minSize: 120,
      mantineTableBodyCellProps: {
        style: { fontFamily: 'Nunito Sans, sans-serif', fontWeight: 600, color: '#595C60' },
      },
    },
    {
      accessorKey: 'username',
      header: 'Username',
      size: 150,
      minSize: 100,
      mantineTableBodyCellProps: {
        style: { fontFamily: 'Nunito Sans, sans-serif', fontWeight: 600, color: '#595C60' },
      },
    },
  ];

  // Conditionally add column depending on userType
  if (userType === 'superadmin') {
    baseColumns.push({
      accessorKey: 'companyName',
      header: 'Company',
      size: 180,
      minSize: 120,
      mantineTableBodyCellProps: {
        style: { fontFamily: 'Nunito Sans, sans-serif', fontWeight: 600, color: '#595C60' },
      },
    });
  } else {
    baseColumns.push({
      accessorKey: 'departmentName',
      header: 'Department',
      size: 180,
      minSize: 120,
      mantineTableBodyCellProps: {
        style: { fontFamily: 'Nunito Sans, sans-serif', fontWeight: 600, color: '#595C60' },
      },
    });
  }


  const table = useMantineReactTable({
    columns: baseColumns,
    data,
    enableRowSelection: true,
    enableStickyHeader: true,
    enableColumnResizing: true,
    enableColumnHiding: true,
    mantineTableContainerProps: {
      style: { overflowX: 'auto', overflowY: 'auto', maxHeight: '400px', paddingLeft: '20px', paddingRight: '20px' },
    },
    mantineTableProps: {
      style: {
        minWidth: 'max-content',
        tableLayout: 'fixed',
        fontFamily: 'Nunito Sans, sans-serif',
        backgroundColor: '#ffffff',
        width: '100%',
      },
      className: 'shadow-sm rounded-lg',
    },
    mantineTableHeadCellProps: {
      style: {
        whiteSpace: 'nowrap',
        backgroundColor: '#F1F4F9',
        borderBottom: '1px solid #e5e7eb',
        padding: '12px',
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: '700',
        fontSize: '14px',
        color: '#202224',
      },
    },
    mantineTableBodyCellProps: {
      style: {
        whiteSpace: 'nowrap',
        padding: '12px',
        height: '48px',
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: '600',
        color: '#595C60',
      },
    },
    mantineSelectCheckboxProps: {
      size: 'sm',
      styles: {
        input: {
          '&:not(:checked)': { border: '1px solid #202224 !important', backgroundColor: 'transparent !important' },
          '&:checked': { border: 'none !important', backgroundColor: '#FF7A00 !important' },
        },
        icon: { color: '#ffffff !important' },
        wrapper: { height: '100%', display: 'flex', alignItems: 'center', backgroundColor: 'transparent !important' },
      },
      className: 'custom-checkbox-cell',
    },
    mantineSelectAllCheckboxProps: {
      size: 'sm',
      styles: {
        input: {
          '&:not(:checked)': { border: '1px solid #202224 !important' },
          '&:checked': { border: 'none !important', backgroundColor: '#FF7A00 !important' },
        },
        icon: { color: '#ffffff !important' },
        wrapper: { borderBottom: '1px solid #e5e7eb' },
      },
    },
    mantineColumnVisibilityToggleButtonProps: {
      sx: {
        color: '#FF7A00 !important',
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        border: 'none',
        backgroundColor: 'transparent',
        '&:hover': { backgroundColor: '#FFF3E5' },
        '& svg': { color: '#FF7A00 !important' },
      },
    },
    mantineTableToolbarProps: {
      sx: {
        '& .mantine-Menu-item': {
          color: '#FF7A00 !important',
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '14px',
          backgroundColor: 'transparent',
          '&:hover': { backgroundColor: '#FFF3E5 !important' },
        },
      },
    },
    meta: { setUsers, onEdit },
  });

  return (
    <div className="mb-5">
   <CommonMantineTable data={data} columns={baseColumns} onEdit={onEdit} onDelete={onDelete} />

      <ConfirmationModal
        open={isModalOpen}
        title="Delete User"
        message="Are you sure you want to delete this user? This action cannot be undone."
        onConfirm={handleConfirmDelete}
        onCancel={() => {
          setIsModalOpen(false);
          setUserToDelete(null);
        }}
        confirmLabel="Confirm"
        cancelLabel="Cancel"
      />
    </div>
  );
};

export default UserTable;
